/** Onboarding 功能统一生效人群判断服务。 */
export interface OnboardingEligibilityService {
    /**
     * 判断当前用户是否满足 onboarding 生效条件。
     * @returns 仅海外个人用户返回 true。
     */
    isEligible(): boolean;
}

/** Onboarding 生效人群服务的容器标识。 */
export const OnboardingEligibilityService = Symbol('OnboardingEligibilityService');
